import React from "react";
import '../Components/css/privacy-policy.css'
import { HashLink as Link } from "react-router-hash-link";
import  Navbar  from "../Components/Navbar2.js";
import '../voices/voices-public-pages.css';
export default function PrivacyAndPolicy() {

    return (
    <>
    <Navbar />
    
    
    
        <main className="vpp-page vpp-policy" data-voices-theme="dark">
          <header className="vpp-intro">
             <h1 >Privacy Policy — Antrazal</h1>
            <p >Effective Date: January 1, 2026</p>
          </header>
          <section className="vpp-reading-layout" data-voices-theme="dark">
            <aside className="vpp-reading-aside">Antrazal / Privacy</aside>
            <article className="privacy-policy vpp-reading-body">
            <p>
                Antrazal (“Company,” “we,” “our,” or “us”) is committed to protecting
                your privacy and safeguarding your personal information. This Privacy
                Policy explains how we collect, use, disclose, store, and protect
                personal data obtained from visitors to our website, users of our
                services, and individuals who communicate with us through any online or
                offline channel (collectively, the “Services”).
            </p>

            <p>
                By accessing or using our Services, you acknowledge that you have read
                and understood this Privacy Policy.
            </p>

            <h2 >Scope of This Policy</h2>
            <p>This Privacy Policy applies to personal information collected through:</p>

            <ul>
                <li>Our website and related digital platforms</li>
                <li>Email, phone, or other communications with us</li>
                <li>Online forms, inquiries, and service requests</li>
                <li>Interactions with our marketing or support teams</li>
            </ul>

            <p>
                This policy does not apply to third-party websites or services that we
                do not control.
            </p>

            <h2 >Information We Collect</h2>
            <p>We may collect personal information that you voluntarily provide, including:</p>

            <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Company name</li>
                <li>Job title</li>
                <li>Inquiry details or messages</li>
                <li>Any other information you choose to submit</li>
            </ul>

            <p>
                Providing personal information is voluntary. However, if you do not
                provide certain information, we may be unable to respond to requests or
                provide services.
            </p>

            <h3>Information Collected Automatically</h3>
            <p>
                When you use our website or digital platforms, we may automatically
                collect technical and usage data such as:
            </p>

            <ul>
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Device type and operating system</li>
                <li>Time zone and general location</li>
                <li>Pages visited and navigation paths</li>
                <li>Referring URLs</li>
                <li>Interaction data such as clicks or scrolling</li>
                <li>Error logs and performance data</li>
            </ul>

            <p>
                This information helps us maintain security, analyze trends, and improve
                user experience.
            </p>

            <h3>Information from Third Parties</h3>
            <p>
                We may receive information about you from third-party sources such as
                marketing partners, analytics providers, public databases, recruitment
                platforms, and service providers. We may combine this information with
                data we already hold about you.
            </p>

            <h2 >Cookies and Tracking Technologies</h2>

            <p>Our website uses cookies and similar tracking technologies to:</p>

            <ul>
                <li>Distinguish users</li>
                <li>Enhance performance</li>
                <li>Analyze traffic</li>
                <li>Personalize content</li>
                <li>Improve usability</li>
                <li>Deliver relevant advertising</li>
            </ul>

            <p>
                You may disable cookies through your browser settings. Disabling cookies
                may limit certain features or functionality.
            </p>

            <p>
                Some browsers include a Do-Not-Track feature. Because there is no
                universal standard for recognizing DNT signals, our systems may not
                respond to them.
            </p>

            <h2 >How We Use Your Information</h2>

            <ul>
                <li>Providing services and responding to inquiries</li>
                <li>Communicating with you</li>
                <li>Processing requests or transactions</li>
                <li>Improving our website and services</li>
                <li>Conducting analytics and research</li>
                <li>Monitoring performance and security</li>
                <li>Sending updates or marketing communications where permitted</li>
                <li>Detecting fraud or misuse</li>
                <li>Complying with legal obligations</li>
            </ul>

            <h2 >Legal Basis for Processing</h2>

            <ul>
                <li>Performance of a contract</li>
                <li>Compliance with legal obligations</li>
                <li>Legitimate business interests</li>
                <li>Protection of rights and safety</li>
                <li>Your consent where required</li>
            </ul>

            <h2 >Sharing and Disclosure of Information</h2>

            <ul>
                <li>Employees and authorized representatives</li>
                <li>Service providers and technology partners</li>
                <li>Analytics and hosting providers</li>
                <li>Marketing or advertising partners where permitted</li>
                <li>Professional advisors</li>
            </ul>

            <p>
                We may disclose information if necessary to comply with legal
                obligations, enforce policies, prevent fraud, or protect rights,
                property, or safety.
            </p>

            <h2 >Business Transfers</h2>
            <p>
                If Antrazal is involved in a merger, acquisition, or sale of assets,
                personal information may be transferred as part of that transaction. We
                will ensure continued protection of your data.
            </p>

            <h2 >International Data Transfers</h2>
            <p>
                Your personal information may be processed in countries outside your
                residence. When transferring data internationally, we implement
                reasonable safeguards consistent with applicable laws.
            </p>

            <h2 >Data Retention</h2>
            <p>
                We retain personal data only as long as necessary to fulfill the
                purposes described in this policy, comply with legal requirements,
                resolve disputes, and enforce agreements.
            </p>

            <h2 >Your Privacy Rights</h2>

            <ul>
                <li>Access your data</li>
                <li>Correct inaccurate data</li>
                <li>Request deletion</li>
                <li>Restrict processing</li>
                <li>Object to processing</li>
                <li>Withdraw consent</li>
                <li>Request data portability</li>
            </ul>

           <h2>Security Measures</h2>
<p>
  We implement appropriate administrative, technical, and physical safeguards
  designed to protect personal data against unauthorized access, disclosure,
  alteration, or destruction. These measures include secure server
  infrastructure, encryption protocols, access controls, monitoring systems,
  and periodic security assessments. We also restrict access to personal data
  only to authorized personnel who require it for legitimate business purposes.
</p>
<p>
  While we take reasonable steps to safeguard information, no method of
  transmission over the internet or electronic storage system is completely
  secure. Therefore, we cannot guarantee absolute security, and users are
  encouraged to take precautions when sharing personal information online.
</p>

<h2>Third-Party Links</h2>
<p>
  Our website may contain links to external websites, services, or applications
  that are operated by third parties. These links are provided for convenience
  and informational purposes only. We do not control, endorse, or assume
  responsibility for the privacy practices, policies, or content of such
  third-party platforms.
</p>
<p>
  When you navigate to third-party websites, you are subject to their terms and
  policies. We recommend reviewing their privacy statements before submitting
  any personal information, as their practices may differ from ours.
</p>

<h2>Children’s Privacy</h2>
<p>
  Our Services are not directed toward or intended for individuals under the
  age of 18. We do not knowingly collect, solicit, or store personal information
  from minors. If we become aware that personal data has been provided by a
  child without appropriate consent, we will take reasonable steps to delete
  such information promptly.
</p>
<p>
  Parents or guardians who believe that a child has submitted personal data to
  us may contact us, and we will take appropriate action to investigate and
  remove the information where required.
</p>

<h2>Updates to This Privacy Policy</h2>
<p>
  We may revise or update this Privacy Policy periodically to reflect changes in
  our practices, technologies, legal requirements, or other operational needs.
  When updates are made, the revised version will be posted on this page along
  with a new effective date.
</p>
<p>
  We encourage users to review this page regularly to stay informed about how
  we protect and use personal information. Continued use of our Services after
  updates become effective constitutes acceptance of the revised policy.
</p>

            <h2 >Contact Information</h2>
            <p>
                <strong>Company:</strong>{" "}
                <a href="/" target="_blank" rel="noopener noreferrer">
                    Antrazal
                </a>
                <br />

                <strong>Email:</strong>{" "}
                <a href="mailto:info@antrazal.com">
                     info@antrazal.com
                </a>
                <br />

                <strong>Contact Page:</strong>{" "}
                <Link style={{cursor:'pointer', color:'inherit', textDecoration:'none'}}
                   to="/#contact-us"
                >
                   Contact Us
                </Link>
            </p>





           </article>
        </section>
        </main>
    </>
    );
}
